import { ServiceOrderType } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { getServiceOrder } from '@mews-commander/legacy-entities/src/ducks';
import { getService } from '@mews-commander/legacy-entities/src/ducks/services';
import { Dash } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { ModalLink } from './Link';

interface ServiceOrderLinkProps {
    serviceOrderId: string;
}

export const ServiceOrderLink = ({ serviceOrderId }: ServiceOrderLinkProps) => {
    const serviceOrder = useCommanderSelector((state) => getServiceOrder(state, { id: serviceOrderId }));
    const service = useCommanderSelector((state) =>
        serviceOrder ? getService(state, { id: serviceOrder?.serviceId }) : null
    );
    const resolveRoute = useResolveRoute();

    if (!serviceOrder || !service) return <Dash />;

    const url =
        serviceOrder.data.discriminator === ServiceOrderType.Reservation
            ? resolveRoute(RouteName.ReservationDetailStatus, {
                  reservationId: serviceOrderId,
              })
            : resolveRoute(RouteName.ServiceOrderDetail, { id: serviceOrderId });

    return (
        <ModalLink data-service-order-link={serviceOrderId} url={url}>
            <LocalizedProperty property={service.names} />
            {UnicodeEntity.NoBreakSpace}
            {serviceOrder.data.value.number}
        </ModalLink>
    );
};
